import React from 'react'

import { useRegion } from '@/entities/regions'

import {
	DIGITAL_RUS_DETAILS,
	DIGITAL_RUS_REGIONS,
	OOO_ITECH_SERVICE_DETAILS,
	OOO_TEHNICHESKIE_SYSTEMI_DETAILS,
	PORTATIVNAYA_TECHINIKA_DETAILS
} from './data'
import { CompanyDetails } from './ui/CompanyDetails/CompanyDetails'

import styles from './BankDetails.module.scss'

export const BankDetails = (): JSX.Element => {
	const { currentRegion } = useRegion()

	const companyDetails = DIGITAL_RUS_REGIONS.includes(currentRegion.REGION_CODE)
		? DIGITAL_RUS_DETAILS
		: PORTATIVNAYA_TECHINIKA_DETAILS

	return (
		<section className={styles.bankDetails}>
			<h1 className={styles.title}>Реквизиты</h1>
			<CompanyDetails {...companyDetails} />
			<CompanyDetails {...OOO_TEHNICHESKIE_SYSTEMI_DETAILS} />
			<CompanyDetails {...OOO_ITECH_SERVICE_DETAILS} />
		</section>
	)
}
